module.exports = __webpack_public_path__ + "teikeibun.no1.f7693eda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/teikeibun.no1.jpg
// module id = bWm1
// module chunks = 0